'use client';

import { createContext } from 'react';
import { SessionType } from './type';
export const SessionContext = createContext<SessionType | undefined>({
  user: null,
  accessToken: null
});
export function SessionProvider({
  session,
  children
}: Readonly<{
  session: SessionType | undefined;
  children: React.ReactNode;
}>) {
  return <SessionContext.Provider value={session ?? {
    user: null,
    accessToken: null
  }} data-sentry-element="unknown" data-sentry-component="SessionProvider" data-sentry-source-file="SessionProvider.tsx">
      {children}
    </SessionContext.Provider>;
}